import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { useNavigate, useLocation } from "react-router-dom";

import { getCookie } from "components/common/cookie.js";
import { UserCreators } from "redux/modules/user";

import Button from "components/common/button/Button";
import BackNavigation from "./common/BackNavigation";
import Benefit_1 from "assets/images/login/benefit1.svg";
import Benefit_2 from "assets/images/login/benefit2.svg";

const Signup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const isRegDone = location.state.isRegDone;

  const isCertificated = useSelector((state) => state.user.isCertificated);

  const fileInput = React.useRef(null);

  const [type, setType] = useState("certification");
  const [imageSrc, setImageSrc] = useState("");
  const [file, setFile] = useState("");

  const certificatedBtnHandler = () => {
    if (type === "certification") {
      setType("upload");
    }
    if (type === "upload") {
      fileInput.current.click();
    }
  };

  const submitHandler = async () => {
    // file.append('token', getCookie('KakaoAccessToken'))
    console.log(file);
    const formdata = new FormData();
    formdata.append("regImage", file);

    console.log(isRegDone);
    if (isRegDone === true) {
      dispatch(UserCreators.updateCertiFile(formdata));
      if (isCertificated === true) {
        dispatch(UserCreators.getUserInfos());
        navigate("/");
      }
    } else {
      formdata.append("token", getCookie("KakaoAccessToken"));
      dispatch(UserCreators.postCertiFile(formdata));
      if (isCertificated === true) {
        navigate("/");
      }
    }
  };

  const handleChange = (e) => {
    console.log(e.target.files[0]);
    setFile(e.target.files[0]);
    const reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    return new Promise((resolve) => {
      reader.onload = () => {
        setImageSrc(reader.result);
        resolve();
      };
    });
  };

  const uncertificatedBtnHandler = () => {
    navigate("/signup/uncertificated");
  };

  return (
    <LoginWrapper>
      <BackNavigation />
      {type === "certification" && (
        <>
          <SignupContainer>
            <Title>
              꽃집 사장님 혜택을 받으려면
              <br />
              사업자 등록증 인증이 필요해요
              <br />
            </Title>
            <Content>
              <p style={{ marginBottom: "3vh" }}>
                사업자 등록증 사진을 올리면, 10초 만에 바로 인증돼요
                <br />
                사업자 인증하고 사장님만을 위한 혜택을 받아가세요!
              </p>
              <img src={Benefit_1} style={{ width: "100%" }} />
            </Content>
          </SignupContainer>
          <Button wide _onClick={certificatedBtnHandler}>
            사진으로 사업자 등록 인증하기
          </Button>
          <UncertificatedBtn onClick={uncertificatedBtnHandler}>
            아직 사업자 등록증이 없다면
          </UncertificatedBtn>
        </>
      )}
      {type === "upload" && !imageSrc && (
        <>
          <SignupContainer>
            <Title>
              꽃집 사장님 혜택을 받으려면
              <br />
              사업자 등록증 인증이 필요해요
              <br />
            </Title>
            <Content>
              <img
                src={Benefit_2}
                style={{ width: "100%", marginTop: "6vh" }}
              />
            </Content>
          </SignupContainer>
          <Button wide _onClick={certificatedBtnHandler}>
            사업자 등록증 사진 올리기
          </Button>
          <input
            type="file"
            ref={fileInput}
            onChange={handleChange}
            style={{ display: "none" }}
          />
          <UncertificatedBtn onClick={uncertificatedBtnHandler}>
            아직 사업자 등록증이 없다면
          </UncertificatedBtn>
        </>
      )}
      {type === "upload" && imageSrc && (
        <>
          <SignupContainer>
            <Title>사업자 등록증 사진을 확인해주세요</Title>
            <Content>
              <p style={{ marginBottom: "3vh" }}>
                사진이 흔들리거나, 선명하지 않다면
                <br />
                사업자 인증이 이뤄지지 않을 수 있어요
              </p>
              <img
                src={imageSrc}
                style={{
                  height: "35vh",
                  marginTop: "1vh",
                  display: "block",
                  margin: "auto",
                }}
              />
            </Content>
          </SignupContainer>
          <Button wide _onClick={submitHandler}>
            사업자 등록증 사진 올리기
          </Button>
          <ChangeBtn onClick={certificatedBtnHandler}>
            사업자 등록증 사진 바꾸기
          </ChangeBtn>
          <input
            type="file"
            ref={fileInput}
            onChange={handleChange}
            style={{ display: "none" }}
          />
        </>
      )}
    </LoginWrapper>
  );
};

const LoginWrapper = styled.div`
  position: relative;
  width: 90%;
  height: 92vh;
  margin: auto;
  padding-top: 15px;
`;

const SignupContainer = styled.div`
  width: 100%;
  position: absolute;
  top: 13vh;
`;

const Title = styled.div`
  font-size: 1.1em;
  font-weight: 600;
  margin-bottom: 2vh;
`;

const Content = styled.div`
  font-size: 0.9em;
  color: #4a5056;
`;

const UncertificatedBtn = styled.div`
  width: 100%;
  font-size: 0.7em;
  position: absolute;
  bottom: 16.5vh;
  text-align: center;
  text-decoration: underline;
  text-underline-position: under;
`;

const ChangeBtn = styled.button`
  width: 100%;
  height: 7vh;
  background-color: #ffffff;
  color: #878e95;
  box-sizing: border-box;
  font-weight: 600;
  position: absolute;
  bottom: 12vh;
  text-align: center;
  vertical-align: middle;
  border: solid 1px #878e95;
  border-radius: 8px;
`;

export default Signup;
